module.exports = __webpack_public_path__ + "img/logo-oficial-envíame.b8958989.png";